import { apiConfig } from "./apiConfig";
import { ELITE_BANNERS_UPLOAD_DIR } from "./uploadFileElite";
import {
  ELITE_MARCA,
  isEliteBanner,
  tagEliteBannerName,
} from "../constants/eliteSite";

const saveBannerElite = async (payload) => {
  return await apiConfig.post("/banners/create", {
    ...payload,
    name: tagEliteBannerName(payload.name),
    marca: ELITE_MARCA,
  });
};

const getBannersElite = async () => {
  const response = await apiConfig.get("/banners");
  const data = Array.isArray(response.data) ? response.data : [];

  return {
    ...response,
    data: data.filter(isEliteBanner),
  };
};

const deleteBannerElite = async (id) => {
  return await apiConfig.delete(`banners/delete/${id}`);
};

const updateBannerElite = async (id, payload) => {
  return await apiConfig.patch(`banners/update/${id}`, {
    ...payload,
    name: tagEliteBannerName(payload.name),
    marca: ELITE_MARCA,
  });
};

export {
  saveBannerElite,
  getBannersElite,
  deleteBannerElite,
  updateBannerElite,
  ELITE_MARCA as ELITE_BANNER_MARCA,
  ELITE_BANNERS_UPLOAD_DIR,
};
